module.exports = __webpack_public_path__ + "static/media/remove_img_icon.d55df842.svg";